<template>
    <div class="modal-content">
        <div class="ico-wrapper">
            <CheckCircle class="ico"/>
        </div>
        <p v-html="componentProps.text"></p>
    </div>
</template>

<script>
import CheckCircle from "@/assets/icons/check-circle-gradient.svg";
export default {
    name: "CheckEmailModal",
    props: ['componentProps'],
    components: { CheckCircle },
}
</script>

<style lang="less" scoped>
    .modal-content{
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
        .ico-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 75px;
            .ico {
                width: 60px;
                height: 60px;
                @media (max-width: 1399px) {
                    width: 52px;
                    height: 52px;
                }
            }
        }
        p {
            text-align: center;
            color: #ffffff;
            font-family: Montserrat;
            font-weight: 500;
            font-size: 14px;
            line-height: 1.5;
            margin-bottom: 6px;
            @media (max-width: 767px) {
                width: 192px;
                margin: 0 auto;
            }
        }
    }
</style>
